module.exports = __webpack_public_path__ + "img/error_404bg-m.bd79926.webp";